<template>
    <!-- Marketing Mode -->
    <section v-if="!settings.is_sourcing_mode">
        <ScrollObserver
            class="absolute top-24"
            @in-viewport="dropdownSeen = false"
            @not-in-viewport="dropdownSeen = true"
        />
        <Transition v-if="!settings.is_sourcing_mode" name="slide-down">
            <div
                v-if="dropdownSeen"
                class="hidden at1024:flex items-center gap-3 w-full bg-white z-20 fixed border-b px-5 py-6 shadow-md"
                style="top: var(--header-height);"
            >
                <a href="#">
                    <span>
                        <BaseSvg
                            name="icon-expand-less"
                            class="fill-gray-650 hover:fill-red"
                        />
                    </span>
                </a>
                <h1 class="font-bold text-base">{{ $t("Resources") }}</h1>
            </div>
        </Transition>

        <div class="flex flex-col at1024:flex-row">
            <div
                class="overflow-hidden p-8 shrink-0 at1024:pr-0 at1024:w-80"
            >
                <h2 class="font-semibold text-xl at1200:text-3xl">
                    New Catalogs
                </h2>

                <CatalogList class="mt-4 pr-4" :resources="newCatalogs" />
            </div>
            <div
                class="p-8 w-full"
            >
                <ResourceSearch
                    :manufacturers="manufacturers"
                    :newVideos="newVideos"
                    v-model="searchTerm"
                />
            </div>
        </div>
    </section>

    <!-- Sourcing Mode -->
    <LeftAsideSubLayout v-else 
        :title="`Resources: Manufacturer Literature`"
    >
        <template #aside>
            <ResourcesAside
                :manufacturers="manufacturers"
                :newCatalogs="newCatalogs"
                v-model="searchTerm"
            />
        </template>
        <template #default>
            <div class="p-10 pt-6">
                <ResourceSearch
                    :manufacturers="manufacturers"
                    :newVideos="newVideos"
                    v-model="searchTerm"
                />
            </div>
        </template>
    </LeftAsideSubLayout>
</template>

<script setup>
import {
    BaseSvg,
    ResourceSearch,
    ScrollObserver,
    CatalogList,
} from "@/Components";
import ResourcesAside from "@/Components/Modules/ResourcesAside.vue";
import { ref } from "vue";
import useUser from "@/Composables/Modules/useUser";
import LeftAsideSubLayout from "@/Layouts/Modules/SubLayouts/LeftAsideSubLayout.vue";

const { settings } = useUser();
const props = defineProps({
    crumbs: {
        type: Array,
        required: true,
    },
    manufacturers: {
        type: Array,
        required: true,
    },
    newCatalogs: {
        type: Array,
        required: true,
    },
    newVideos: {
        type: Array,
        required: true,
    },
    pinnedResources: {
        type: Array,
        required: false,
    },
});

const dropdownSeen = ref(false);
const searchTerm = ref('');

// removed selectedManufacturer and scroll handlers as they are now inside ResourcesAside
</script>
